import { Row, Col } from 'react-bootstrap';

export default function NossosServicos() {
    return (
        <Row>
            <Col xs="12">
                <p><small>Você está em <a href="/institucional">Institucional</a> / Nossos Serviços</small></p>
            </Col>
            <Col xs="12">
                <h1>NOSSOS SERVIÇOS</h1>
                <p>A Alepe tem diversos serviços que podem ser acessados por meio digital, entre eles, destacam-se:</p>
                <ul>
                    <li style={{ marginBottom: '10px' }}>
                        <strong>Alepe Legis:</strong> <a href="https://legis.alepe.pe.gov.br/">Acesse o Portal da Legislação Estadual de Pernambuco</a>
                    </li>
                    <li style={{ marginBottom: '10px' }}>
                        <strong>E-SIC:</strong> <a href="https://transparencia.alepe.pe.gov.br/ouvidoria/nova-soliticacao">Faça seu pedido de informação</a>
                    </li>
                    <li style={{ marginBottom: '10px' }}>
                        <strong>Tv Alepe:</strong> <a href="https://www.youtube.com/@assembleiape">Fique por dentro de tudo que acontece na Alepe</a>
                    </li>
                    <li style={{ marginBottom: '10px' }}>
                        <strong>Proposições:</strong> <a href="https://www.alepe.pe.gov.br/proposicoes">Saiba quais projetos estão tramitando na Assembleia</a>
                    </li>
                    <li style={{ marginBottom: '10px' }}>
                        <strong>Municípios Pernambucanos:</strong> <a href="https://www.alepe.pe.gov.br/municipios">Acompanhe a legislação estadual dos municípios de Pernambuco</a>
                    </li>
                    <li style={{ marginBottom: '10px' }}>
                        <strong>Calendário Oficial de Eventos e Datas Comemorativas:</strong> <a href="https://legis.alepe.pe.gov.br/calendario.aspx">Conheça o nosso calendário oficial do Estado de Pernambuco</a>
                    </li>
                    <li style={{ marginBottom: '10px' }}>
                        <strong>App Está na Lei:</strong> <a href="https://www.alepe.pe.gov.br/aplicativos">Conheça as normas do Estado por meio de textos curtos e de fácil compreensão</a>
                    </li>
                    <li style={{ marginBottom: '10px' }}>
                        <strong>Dados Abertos:</strong> <a href="https://dadosabertos.alepe.pe.gov.br/">Acesse nosso portal de dados abertos</a>
                    </li>
                </ul>
            </Col>
        </Row>
    );
}
